<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title class="cardTitle">
      <h1>{{ "recurringOrders.create.title" | translate }}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-progress-bar
      *ngIf="isLoading"
      class="progress-bar"
      mode="indeterminate"
      color="accent"
    >
    </mat-progress-bar>

    <form
      [formGroup]="clientForm"
      *ngIf="!isAdminWithOneClient && isAdmin && !isLoading"
      class="formClient"
    >
      <app-autocomplete
        [control]="getClientControl('client')"
        [list]="clients"
        label="users.edit.clients.select.label"
      >
      </app-autocomplete>
      <button
        type="button"
        mat-raised-button
        color="primary"
        (click)="chooseClient()"
        [disabled]="clientForm.invalid"
      >
        Choisir agence
      </button>
    </form>

    <form
      class="edit-form"
      [formGroup]="editForm"
      (submit)="onSubmit()"
      *ngIf="editForm && canChooseValue"
    >
      <fieldset>
        <legend>Fréquence</legend>

        <mat-form-field class="creation-time-field">
          <mat-label>Heure de création</mat-label>
          <input
            id="inputTime"
            matInput
            type="time"
            matInput
            formControlName="creationTime"
          />
        </mat-form-field>

        <mat-form-field class="start-time-field">
          <mat-label>Heure de départ</mat-label>
          <input
            id="startTime"
            matInput
            type="time"
            matInput
            formControlName="startTime"
          />
        </mat-form-field>

        <!-- <mat-form-field class="description-field">
          <mat-label>Description</mat-label>
          <input type="text" matInput formControlName="cronDescription">
        </mat-form-field> -->

        <fieldset class="fieldsetRecurrency">
          <legend>Récurrence</legend>
          <div class="recurrencySection">
            <mat-radio-group
              aria-label="Récurrence"
              class="recurrency-field"
              formControlName="recurrency"
            >
              <mat-radio-button
                *ngFor="let recurrency of recurrencies"
                [value]="recurrency.value"
                >{{ recurrency.name }}
              </mat-radio-button>
            </mat-radio-group>
          </div>

          <div
            *ngIf="editForm.value.recurrency === 'daily'"
            class="dailyRecurrency"
          >
            <mat-radio-group
              aria-label="Récurrence"
              class="dailyRecurrency-field"
              formControlName="dailyRecurrency"
            >
              <mat-radio-button *ngFor="let mode of daily" [value]="mode.value">
                {{ mode.name }}
              </mat-radio-button>
            </mat-radio-group>

            <mat-button-toggle-group
              *ngIf="editForm.value.dailyRecurrency === 'custom'"
              appearance="legacy"
              name="truc"
              aria-label="Font Style"
              multiple="true"
            >
              <mat-button-toggle
                *ngFor="let day of days"
                [value]="day"
                (change)="selectDay($event, day)"
              >
                {{ showDayText(day.value) | translate }}
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>

          <div
            *ngIf="editForm.value.recurrency === 'weekly'"
            class="weeklyRecurrency"
          >
            <p class="inputWeeklyRecurrency">
              Toutes les
              <input formControlName="weeklyRecurrency" type="number" />
              semaines
            </p>
            <mat-button-toggle-group
              appearance="legacy"
              name="fontStyle"
              aria-label="Font Style"
              multiple="true"
            >
              <mat-button-toggle
                *ngFor="let day of days"
                [value]="day"
                (change)="selectDay($event, day)"
              >
                {{ showDayText(day.value) | translate }}
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>

          <div
            *ngIf="editForm.value.recurrency === 'monthly'"
            class="monthlyRecurrency"
          >
            <!-- <mat-radio-group aria-label="Récurrence" class="dailyRecurrency-field"
            formControlName="monthlyRecurrency"> -->
            <!-- <mat-radio-button value="day"> -->
            Le
            <input
              formControlName="dayMonthlyRecurrency"
              type="number"
              min="1"
              max="31"
              oninput="this.value =
              !!this.value && Math.abs(this.value) > 0 ? Math.abs(this.value) : null"
            />
            tous les mois
            <!-- </mat-radio-button> -->
            <!-- <mat-radio-button value="the">
              Le
              <mat-select formControlName="nthDayMonthlyRecurrency" appearance="legacy" class="selectField">
                <mat-option *ngFor="let nthDay of nthDays" [value]="nthDay.value">
                  {{nthDay.name}}
                </mat-option>
              </mat-select>
              <mat-select formControlName="dayChoosedMonthlyRecurrency" appearance="legacy" class="selectField">
                <mat-option *ngFor="let day of days" [value]="day.value">
                  {{showDayText(day.value) | translate}}
                </mat-option>
              </mat-select>
              de tous les <input formControlName="nthMonthMonthlyRecurrency" type="number"> mois
            </mat-radio-button> -->
            <!-- </mat-radio-group> -->
          </div>

          <div
            *ngIf="editForm.value.recurrency === 'interval'"
            class="intervalRecurrency"
          >
            <div>
              <mat-form-field>
                <mat-label>Date de création</mat-label>
                <input
                  matInput
                  [matDatepicker]="intervalCreationDatePicker"
                  [min]="today"
                  formControlName="intervalCreationDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="intervalCreationDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #intervalCreationDatePicker></mat-datepicker>
              </mat-form-field>

              <br />

              <mat-form-field>
                <mat-label>Date de départ</mat-label>
                <input
                  matInput
                  [matDatepicker]="intervalStartDatePicker"
                  [min]="today"
                  formControlName="intervalStartDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="intervalStartDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #intervalStartDatePicker></mat-datepicker>
              </mat-form-field>
            </div>

            <div>
              <p class="inputIntervalRecurrency">
                Tous les
                <input formControlName="intervalRecurrency" type="number" />
                jours
              </p>
            </div>
          </div>
        </fieldset>
      </fieldset>

      <div class="ordererSiteSection">
        <section>
          <h3>
            Etablissement ({{ "orders.create.site.label" | translate }})
            <span class="red">*</span>
          </h3>
          <app-autocomplete
            [canString]="true"
            label="orders.create.site.label"
            class="site-field"
            [control]="getControl('site')"
            [list]="sites"
            [setSites]="sites"
            errorMsg="orders.create.site.errorMessage"
          >
          </app-autocomplete>
        </section>

        <section class="ordererSection">
          <h3>Demandeur</h3>
          <div class="ordererFields">
            <mat-form-field class="ordererName-field">
              <mat-label>{{
                "orders.create.ordererName.label" | translate
              }}</mat-label>
              <input matInput formControlName="ordererName" />
              <mat-error
                >{{ "orders.create.ordererName.errorMessage" | translate }}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="ordererPhone-field">
              <mat-label>{{
                "orders.create.ordererPhone.label" | translate
              }}</mat-label>
              <input matInput formControlName="ordererPhone" />
              <mat-error
                >{{ "orders.create.ordererPhone.errorMessage" | translate }}
              </mat-error>
            </mat-form-field>

            <section
              *ngIf="
                lots &&
                lots.length > 0 &&
                !isLoadingLots &&
                editForm.get('site').value
              "
            >
              <app-autocomplete
                [control]="getControl('lot')"
                [list]="lots"
                label="orders.create.lot"
              ></app-autocomplete>
            </section>
          </div>
        </section>
      </div>

      <section>
        <h3>Commentaires sur la course</h3>
        <mat-form-field class="comment-field">
          <textarea
            matInput
            rows="5"
            formControlName="ordererComment"
          ></textarea>
          <mat-error
            >{{ "orders.create.ordererComment.error" | translate }}
          </mat-error>
        </mat-form-field>
      </section>

      <section>
        <h3>
          {{ "orders.create.transportType.label" | translate }}
          <span class="red">*</span>
        </h3>
        <!-- <mat-list formArrayName="transportTypes" class="transportTypes-list">
          <mat-list-item *ngFor="let transportType of allTransportTypes; index as i">
            <mat-checkbox [value]="transportType" value="transportType" (change)="onCheckboxChange($event)">
              {{transportType.name}}</mat-checkbox>
          </mat-list-item>
        </mat-list> -->

        <mat-form-field class="devicesChipList">
          <mat-chip-grid #chipList aria-label="Device selection">
            <mat-chip-row
              *ngFor="let selected of transportTypesSelected"
              [selectable]="selectable"
              [removable]="removable"
              (removed)="remove(selected)"
            >
              {{ selected.name }}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip-row>
            <input
              placeholder="Sélectionnez un type de transport"
              #deviceInput
              id="deviceChipList"
              [formControl]="transportTypesCtrl"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="addOnBlur"
              [matAutocomplete]="auto"
              [matChipInputFor]="chipList"
            />
            <button
              type="button"
              mat-icon-button
              color="primary"
              *ngIf="transportTypesSelected.length > 0"
              (click)="clearDevicesSelected()"
            >
              <mat-icon class="clearButton" (click)="clearDevicesSelected()"
                >clear</mat-icon
              >
            </button>
          </mat-chip-grid>
          <mat-autocomplete
            class="devicesDropdown"
            #auto="matAutocomplete"
            (optionSelected)="selected($event)"
          >
            <mat-option
              *ngFor="let device of filteredTransportTypes | async"
              [value]="device"
              [disabled]="device.selected"
            >
              {{ device.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </section>

      <section>
        <h3>
          {{ "orders.create.urgencyLevel" | translate }}
          <span class="red">*</span>
        </h3>
        <mat-radio-group
          aria-label="Sélectionnez un niveau d'urgence"
          class="urgency-field"
          formControlName="urgencyLevel"
        >
          <mat-radio-button
            *ngFor="let urgencyLevel of urgencyLevels"
            [value]="urgencyLevel"
            >{{ urgencyLevel.name }}
          </mat-radio-button>
        </mat-radio-group>
      </section>

      <fieldset formGroupName="sender" class="fieldsetSender">
        <legend>Lieu d'enlèvement<span class="red">*</span></legend>
        <section>
          <h3>Adresse <span class="red">*</span></h3>
          <app-autocomplete
            class="site-field"
            [control]="editForm.get('sender').get('address')"
            [list]="senders"
            errorMsg="orders.create.sender.errorMessage"
            [canString]="true"
          >
          </app-autocomplete>

          <!-- <mat-radio-group aria-label="Sélectionnez un lieu d'enlèvement" class="sender-field"
            formControlName="address">
            <mat-radio-button *ngFor="let sender of senders" [value]="sender">{{sender.name}}</mat-radio-button>
            <mat-radio-button class="otherSender" value="autre">
              <mat-form-field>
                <input formControlName="otherAddress" matInput type="text" placeholder="Autre">
              </mat-form-field>
            </mat-radio-button>
          </mat-radio-group> -->
        </section>

        <section>
          <h3>
            {{ "orders.create.senderService.label" | translate }}
            <span class="red">*</span>
          </h3>
          <mat-form-field class="senderService-field">
            <input matInput formControlName="service" />
            <mat-error
              >{{ "orders.create.senderService.errorMessage" | translate }}
            </mat-error>
          </mat-form-field>
        </section>

        <section>
          <h3>{{ "orders.create.ordererComment.title" | translate }}</h3>
          <mat-form-field class="comment-field">
            <textarea
              matInput
              rows="5"
              formControlName="ordererComment"
            ></textarea>
            <mat-error
              >{{ "orders.create.ordererComment.error" | translate }}
            </mat-error>
          </mat-form-field>
        </section>
      </fieldset>

      <section *ngIf="isControlSet('receivers')">
        <mat-list formArrayName="receivers">
          <mat-list-item
            class="oneReceiver"
            *ngFor="let control of getArray('receivers').controls; index as i"
            [formGroupName]="i"
          >
            <div matLine>
              <fieldset>
                <legend>
                  <span *ngIf="getArray('receivers').controls.length === 1"
                    >Lieu du destinataire</span
                  >
                  <span *ngIf="getArray('receivers').controls.length > 1"
                    >Étape {{ i + 1 }}
                  </span>
                  <span *ngIf="i === 0" class="red">*</span>
                </legend>

                <section *ngIf="getArray('receivers').controls.length > 1">
                  <mat-radio-group formControlName="type">
                    <mat-radio-button value="isDelivery"
                      >Livraison</mat-radio-button
                    >
                    <mat-radio-button value="isPickup"
                      >Enlèvement</mat-radio-button
                    >
                  </mat-radio-group>
                </section>

                <section>
                  <h3>Adresse <span class="red">*</span></h3>
                  <app-autocomplete
                    class="site-field"
                    [control]="control.get('address')"
                    [list]="receivers"
                    errorMsg="orders.create.receiver.errorMessage"
                    [canString]="true"
                  >
                  </app-autocomplete>
                </section>

                <section>
                  <h3>
                    {{ "orders.create.receiverService.label" | translate }}
                    <span class="red">*</span>
                  </h3>
                  <mat-form-field class="receiverService-field">
                    <input matInput formControlName="service" />
                    <mat-error
                      >{{
                        "orders.create.receiverService.errorMessage" | translate
                      }}
                    </mat-error>
                  </mat-form-field>
                </section>

                <section>
                  <h3>
                    {{ "orders.create.ordererComment.title" | translate }}
                  </h3>
                  <mat-form-field class="comment-field">
                    <textarea
                      matInput
                      rows="5"
                      formControlName="ordererComment"
                    ></textarea>
                    <mat-error
                      >{{ "orders.create.ordererComment.error" | translate }}
                    </mat-error>
                  </mat-form-field>
                </section>
              </fieldset>
            </div>
            <button
              *ngIf="i !== 0"
              type="button"
              matTooltip="Retirer le destinataire"
              mat-icon-button
              color="primary"
              (click)="onRemoveReceiver(i)"
            >
              <mat-icon aria-label="delete">delete</mat-icon>
            </button>
          </mat-list-item>
          <mat-list-item
            *ngIf="!isClient && getArray('receivers').controls.length < 100"
          >
            <button
              type="button"
              mat-icon-button
              color="primary"
              matTooltip="Ajouter un destinataire"
              (click)="onAddReceiver()"
            >
              <mat-icon aria-label="Add">add</mat-icon>
            </button>
          </mat-list-item>
        </mat-list>
      </section>

      <section class="actions">
        <div
          class="checkButton"
          [matTooltip]="invalidMessage"
          [matTooltipDisabled]="
            editForm.valid &&
            transportTypesSelected.length !== 0 &&
            this.editForm.value.receivers[
              this.editForm.value.receivers.length - 1
            ].type !== 'isPickup'
          "
        >
          <button
            *ngIf="!isLoading"
            type="submit"
            mat-icon-button
            color="primary"
            [disabled]="
              editForm.invalid ||
              transportTypesSelected.length === 0 ||
              this.editForm.value.receivers[
                this.editForm.value.receivers.length - 1
              ].type === 'isPickup'
            "
          >
            <mat-icon aria-label="Validate">check</mat-icon>
          </button>
        </div>

        <button
          *ngIf="!isLoading"
          type="button"
          mat-icon-button
          (click)="onFinish()"
        >
          <mat-icon aria-label="Cancel">clear</mat-icon>
        </button>
        <mat-spinner
          *ngIf="isLoading"
          [diameter]="35"
          color="primary"
        ></mat-spinner>
      </section>
    </form>
  </mat-card-content>
</mat-card>
